import { Image } from '@react-pdf/renderer';
import checked from '../../../../assets/icons/checkboxchecked.png';
import unChecked from '../../../../assets/icons/checkboxunchecked.png';

const PDFCheckBoxImg = ({ isChecked, size = 16 }) => {
  return <Image src={isChecked ? checked : unChecked} style={{ width: size, height: size }} />;
};

export default PDFCheckBoxImg;
